
import Vue from 'vue';
import { Avatar, Icon } from '@descomplica/vue-components';
import { DiscussionModel } from '../../models/forumAPI/DiscussionModel';
import { getPaddedDisplayNumber } from '@/helpers/string';
import { timeSinceCreation } from '@/helpers/date';
import { UnifiedCommentModel } from '@/models/UnifiedCommentModel';

export default Vue.extend({
  name: 'DiscussionItem',
  components: {
    Icon,
    Avatar,
  },
  props: {
    discussion: {
      type: Object as Vue.PropType<DiscussionModel>,
      required: true,
    },
  },
  computed: {
    name(): string {
      return this.discussion && this.discussion.userProfileName
        ? this.discussion.userProfileName
        : 'Aluno do Descomplica';
    },
    postElapsedTime(): string {
      return timeSinceCreation(this.discussion.createdAt);
    },
    commentsCount(): number {
      return this.discussion.comments.length;
    },
    authorVisibles(): UnifiedCommentModel[] {
      return this.discussion.comments.slice(0, 4);
    },
    hasComments(): boolean {
      return this.discussion.comments && this.discussion.comments.length > 0;
    },
    paddedCommentsCount(): string {
      return getPaddedDisplayNumber(this.commentsCount);
    },
  },
});
